<script setup>
import { ref } from 'vue'
import { v4 as uuidv4 } from 'uuid'
// model
const model = defineModel()

// props
const props = defineProps({
  id: {
    type: String,
    default: () => uuidv4()
  },
  value: {
    type: [String, Object],
    default: '',
  },
})

// data - ref
const checkbox = ref(null)

// expose
defineExpose({ checkbox })

// emit
const emit = defineEmits(['checkboxChange'])
</script>

<template>
  <input ref="checkbox" v-model="model" class="form-check-input" type="checkbox" :value="value" :id="id" @change="emit('checkboxChange', $event)">
</template>